import React, { useEffect, useRef } from 'react';

export interface ClickAwayListenerProps {
  children: any;
  onClickAway: (event: MouseEvent) => void;
}

function ownerDocument(node?: HTMLElement | null): Document {
  return (node && node.ownerDocument) || document;
}

const ClickAwayListener: React.FC<ClickAwayListenerProps> = (props) => {
  const { children, onClickAway } = props;

  const nodeRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const doc = ownerDocument(nodeRef.current);

    function handleDocumentClick(event: MouseEvent): void {
      if (
        doc.documentElement.contains(event.target as HTMLElement) &&
        nodeRef &&
        nodeRef.current &&
        !nodeRef.current.contains(event.target as HTMLElement)
      ) {
        onClickAway(event);
      }
    }

    doc.addEventListener('click', handleDocumentClick);
    return (): void => doc.removeEventListener('click', handleDocumentClick);
  }, [onClickAway]);

  return <span ref={nodeRef}>{children}</span>;
};

export default ClickAwayListener;
